<template>
 <span 
      @click.stop="templet.is_jump({href:`#/product?id=${item.goods_id}&tag_id=${item.tag_ids}`,target:fromTag === 'search' ? '_blank' : pc_infor.target})"
      class="basic_button height_fill" :style="{
        width: listArr.module_style == 2 || listArr.module_style == 4 ? 'auto' : '100%'
      }">
        <div class="buttonContent" 
      :class="pc_infor.button_text.styleType"
      :style="{
        height: '100%',
        '--borderSeColor': borderSeColor,
        '--borderColor': borderColor,
        '--backgroundColor': backgroundColor,
        '--backgroundSeColor': backgroundSeColor,
        '--fontColor': fontColor,
        '--fontSeColor': fontSeColor,
        borderStyle:pc_infor.button_text.buttonStyle.borderStyle,
        borderWidth:pc_infor.button_text.buttonStyle.borderWidth + 'px',
        borderRadius: pc_infor.button_text.buttonStyle.borderRadius + 'px'
      }">
        <div class="bothHeight">
            <span class="btnLink">
              <div class="edit-div btnWords" :style="{
              fontSize: (pc_infor.product_name_font[pc_infor.product_name_font.radio_val].fontSize - 4) + 'px',
              fontFamily: pc_infor.product_name_font[pc_infor.product_name_font.radio_val].fontFamily
            }">{{pc_infor.button_text.value}}</div>
              <span class="after"></span>
            </span>
          </div>
      </div>
 </span>
</template>

<script>
import i18n from '../../../language/index'

export default {
  name: "detail_button",
  data() {
    return {
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    item: {
      type: Object,
      default: null
    },
    fromTag: { // 是否为全局搜索挂件
      type: String,
      default: ''
    }
  },
  watch: {},
  methods: {
  },
  computed: {
    listArr() {
      return this.module.data.listArr
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor
    },
    borderColor() {
      return this.pc_infor.button_text.buttonStyle.borderColor;
    },
    borderSeColor() {
      return this.pc_infor.button_text.buttonStyle.borderSeColor;
    },
    backgroundColor() {
      return this.pc_infor.button_text.buttonStyle.backgroundColor;
    },
    backgroundSeColor() {
      return this.pc_infor.button_text.buttonStyle.backgroundSeColor;
    },
    fontColor() {
      return this.pc_infor.button_text.buttonStyle.fontColor;
    },
    fontSeColor() {
      return this.pc_infor.button_text.buttonStyle.fontSeColor;
    },
  },
  components: {},
  created() {
  },
  mounted() {
  }
};
</script>

<style scoped lang="scss">
.basic_button {
  display: inline-block;
  .buttonContent {
    transition: all 0.6s;
    background: var(--backgroundColor);
  }
  .edit-div {
    min-height: 100%;
    padding: 8px 20px;
  }
  .btnLink {
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -moz-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
    text-align: center;
    vertical-align: middle;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: all 0.3s;
    -o-transition: all 0.3s;
    -moz-transition: all 0.3s;
    transition: all 0.3s;
    -webkit-transform-style: preserve-3d;
    -moz-transform-style: preserve-3d;
    transform-style: preserve-3d;
    .linkPart {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
    }
    .after {
      pointer-events: none;
    }
  }
}
.basic_button .btnLink  .btnWords {
  height: unset;
  text-align: center;
  cursor: pointer;
  white-space: nowrap;
  min-width: 10px;
  overflow: hidden;
  display: block;
  width: 100%;
  position: relative;
  outline: 0;
  margin: 0 8px;
}
.basic_button .buttonContent.type_0 {
  border-radius: 4px;
  border-color: var(--borderColor);
  color: var(--fontColor);
  position: relative;
  background: var(--backgroundColor);
  .after {
    display: block;
    transition: all 0.6s;
    width: 100%;
    height: 0;
    border-radius: 50%;
    left: 50%;
    top: 50%;
    padding-top: 100%;
    position: absolute;
    z-index: 0;
    transform: translateX(-50%) translateY(-50%);
  }
}

.basic_button .buttonContent.type_0:hover {
  .after {
    -webkit-animation: button_style_0_anim 0.75s;
    -moz-animation: button_style_0_anim 0.75s;
    -o-animation: button_style_0_anim 0.75s;
    animation: button_style_0_anim 0.75s;
    z-index: 1;
  }
}

.basic_button .buttonContent.type_0:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_1 {
  border-radius: 20px;
  color: var(--fontColor);
  position: relative;
  background: var(--backgroundColor);
  border: 1px solid var(--borderColor);
}
.basic_button .buttonContent.type_1:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_2 {
  border-radius: 4px;
  color: var(--fontColor);
  border-color: var(--borderColor);
}

.basic_button .buttonContent.type_2:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_3 {
  border-radius: 20px;
  color: var(--fontColor);
  background: var(--backgroundColor);
  border-width: 1px;
  border-style: solid;
  border-color: var(--borderColor);
}
.basic_button .buttonContent.type_3:hover {
  color: var(--fontSeColor);
  border: 1px solid var(--borderSeColor);
  background: var(--backgroundSeColor);
}
.basic_button .buttonContent.type_4 {
  background: var(--backgroundColor);
  color: var(--fontColor);
  border: 1px solid var(--borderColor);
}
.basic_button .buttonContent.type_4:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
  border: 1px solid var(--borderSeColor);
}
.basic_button .buttonContent.type_5 {
  background: var(--backgroundColor);
  color: var(--fontColor);
  border: 1px solid var(--borderColor);
  position: relative;
  .btnWords {
    position: relative;
  }
  .after {
    display: block;
    width: 0%;
    height: 100%;
    background: var(--backgroundColor);
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    transition: all 0.3s;
    z-index: -1;
  }
}
.basic_button .buttonContent.type_5:hover {
  color: var(--fontSeColor);
  .btnWords {
    color: var(--fontSeColor);
  }
  .after {
    background: var(--backgroundSeColor);
    border: 1px solid var(--borderSeColor);
    opacity: 1;
    width: 100%;
  }
}
.bothHeight {
  height: 100%;
}

.basic_button .buttonContent:hover {
  color: var(--fontSeColor);
  background: var(--backgroundSeColor);
  border: 1px solid var(--borderSeColor);
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_product_display/components/detail_button.vue